import React from 'react';
import { useTranslation } from 'react-i18next';
import { Compass, Workflow, Globe } from 'lucide-react';
import { Container, SectionHeading, GlassCard, IconBadge } from './shared';

const ICONS = [Compass, Workflow, Globe];
const CARD_KEYS = ['aiStrategy', 'processOptimization', 'websites'];

const AdditionalServices: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 sm:py-32">
      <Container>
        <SectionHeading
          eyebrow={t('landing.additionalServices.eyebrow')}
          title={t('landing.additionalServices.title')}
        />

        <div className="mt-16 grid gap-6 sm:grid-cols-3">
          {CARD_KEYS.map((key, i) => {
            const Icon = ICONS[i];
            return (
              <GlassCard key={key} index={i}>
                <IconBadge>
                  <Icon className="h-6 w-6 text-white" />
                </IconBadge>
                <h3 className="mb-3 text-xl font-semibold text-white">
                  {t(`landing.additionalServices.cards.${key}.title`)}
                </h3>
                <p className="leading-relaxed text-brand-muted">
                  {t(`landing.additionalServices.cards.${key}.description`)}
                </p>
              </GlassCard>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default AdditionalServices;
